<div  fxLayoutAlign="center center"      [style.font-size]="item.customField18" [ngStyle.lt-md]="{ 'font-size': item.customField17 }">
    {{item.title}}
</div>

<div *ngIf="urlExist" id="outerContainer">

    <pdf-viewer [src]="url" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="false" [zoom]="1"
        [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true" [external-link-target]="'blank'"
        [autoresize]="true" [show-borders]="false" style="width: 100%; height: 100vh;"></pdf-viewer>
</div>